export * from './datasource';
export * from './datasource.interface';
export * from './data.service';
export * from './feature-datasource';
export * from './feature-datasource.interface';
export * from './osm-datasource';
export * from './osm-datasource.interface';
export * from './xyz-datasource';
export * from './xyz-datasource.interface';
export * from './wfs-datasource';
export * from './wfs-datasource.interface';
export * from './wfs-datasource.service';
export * from './wms-datasource';
export * from './wms-datasource.interface';
export * from './wmts-datasource';
export * from './wmts-datasource.interface';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/datasource/shared/datasources/index.ts